import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';

const EnrollForm = (props) => {
  const navigate = useNavigate();
  const BACKEND_URL = process.env.REACT_APP_BACKEND_ADDRESS;

  const [inpval, setInpval] = useState({
    fullName: "",
    email: "",
    mobileNumber: "+91",
    college: "",
    course: "",
    yearOfStudy: "",
    branchName: ""
  });

  const setval = (e) => {
    const { name, value } = e.target;
    setInpval((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const saveData = async (e) => {
    e.preventDefault();
    const { fullName, email, mobileNumber } = inpval;

    if (!fullName || !email || !mobileNumber) {
      toast.error("Please fill in all required fields.");
      return;
    }
    let interestedCourse = 'Linux'
    let remark = "applied for linux internship"
    try {
      const data = await fetch(`${BACKEND_URL}/enquiry`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({...inpval,interestedCourse,remark})
      });

      const res = await data.json();

      if (res.success) {
        toast.success("Registered successfully!");
        setInpval({
          fullName: "",
          email: "",
          mobileNumber: "+91",
          college: "",
          course: "",
          yearOfStudy: "",
          branchName: ""
        });
        setTimeout(() => {
            props.closeModel() 
        }, 1000); 
      }
    } catch (error) {
      console.error("Error submitting data:", error);
      toast.error("Server error. Try again later.");
    }
  };

  return (
    <>
      <div className={`PopUpmodal`} id="MainParentPopup">
        <div className="modalPopUpcontent">
          <div className="modal-header">
            <h4 className="modal-title">Apply Now for Summer Internship Program</h4>
            <button
              type="button"
              className="close close-button"
              onClick={props.closeModel}
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="w3l-contacts-12 home_form">
              <div className="contacts12-main">
                <form className="main-input">
                  <input
                    type="text"
                    placeholder="Full Name *"
                    name="fullName"
                    value={inpval.fullName}
                    onChange={setval}
                    required
                  />
                  <input
                    type="email"
                    placeholder="Email *"
                    name="email"
                    value={inpval.email}
                    onChange={setval}
                    required
                  />
                  <input
                    type="text"
                    placeholder="Mobile Number *"
                    name="mobileNumber"
                    value={inpval.mobileNumber}
                    onChange={setval}
                    required
                  />
                  <input
                    type="text"
                    placeholder="College Name"
                    name="college"
                    value={inpval.college}
                    onChange={setval}
                  />
                  <input
                    type="text"
                    placeholder="Course (e.g. B.Tech, BCA)"
                    name="course"
                    value={inpval.course}
                    onChange={setval}
                  />
                  <input
                    type="text"
                    placeholder="Year of Study (e.g. 2nd Year)"
                    name="yearOfStudy"
                    value={inpval.yearOfStudy}
                    onChange={setval}
                  />
                  <input
                    type="text"
                    placeholder="Branch Name"
                    name="branchName"
                    value={inpval.branchName}
                    onChange={setval}
                  />
                  <div className="mt-3 mt-md-3">
                    <button type="submit" onClick={saveData} className="YellowBTN">
                      Submit Now
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Toaster />
    </>
  );
};

export default EnrollForm;
